import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import rightArrow from "../../../../assets/img/arrow-right.svg";
import upload_icon from "../../../../assets/img/upload_icoon.svg";
import { showToast, ToastContainer } from "../../../../util/toastHelper";
import {
    ADMIN_CMS_TESTIMONIALS,
    ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS,
} from "../../../../action/apiPath";
import { createShortNameFile, errorMessageCreate } from "../../../../util/custom";
import { ADMINCMSTESTIMONIALPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";
import { CallWithAuth } from "../../../../action/apiActions";

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminTestimonialUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [testimonial, setTestimonial] = useState({
        quote: "",
        author_name: "",
        author_title: "",
        author_image: ""
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        fetchTestimonial();
    }, [id]);

    const fetchTestimonial = async () => {
        setIsLoading(true);
        try {
            const response = await CallWithAuth("GET", `${ADMIN_CMS_TESTIMONIALS}/${id}`);
            if (response?.res?.status === 200) {
                const data = response?.res?.data?.data;
                setTestimonial({
                    quote: data.quote,
                    author_name: data.author_name,
                    author_title: data.author_title,
                    author_image: data.author_image,
                });
            } else {
                showToast("error", "Failed to fetch testimonial.");
            }
        } catch (err) {
            console.error(err);
            showToast("error", "An error occurred while fetching testimonial.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        if (name == 'author_name') {
            value = value.replace(/[^a-zA-Z. ]/g, '');
        }
        setTestimonial({ ...testimonial, [name]: value });
    };


    const handleSubmit = async () => {
        if (!testimonial.quote) {
            showToast("error", "Quote is required.");
            return;
        }

        if (!testimonial.author_name) {
            showToast("error", "Author name is required.");
            return;
        }

        if (!testimonial.author_title) {
            showToast("error", "Author title is required.");
            return;
        }

        if (!testimonial.author_image) {
            showToast("error", "Please upload the author's image.");
            return;
        }

        try {
            setIsSubmit(true);

            const response = await CallWithAuth("PATCH", `${ADMIN_CMS_TESTIMONIALS}/${id}`, testimonial);
            const message = errorMessageCreate(response?.res?.data?.message);

            if (response?.res?.status === 200) {
                showToast("success", message);
                setTimeout(() => {
                    navigate(ADMINCMSTESTIMONIALPAGE);
                }, 1000);
            } else {
                showToast("error", message);
            }
        } catch (err) {
            console.error(err);
            showToast("error", "Failed to update testimonial.");
        } finally {
            setIsSubmit(false);
        }
    };


    const uploadImage = async (file) => {
        try {
            setIsLoading(true);
            const formdata = new FormData();
            formdata.append("file", file);
            const response = await CallWithAuth("POST", ADMIN_CMS_TESTIMONIALS_IMAGE_UPLOAD_AWS, formdata);

            if (response?.res?.status === 200 || response?.res?.status === 201) {
                showToast("success", "Author image uploaded successfully.");
                setTestimonial(prevData => ({
                    ...prevData,
                    author_image: response?.res?.data?.file_url
                }));
            } else {
                showToast("error", "Image upload failed.");
            }
        } catch (err) {
            const message = err?.response?.data?.message || err?.message || "Image upload failed. Please try again.";
            showToast("error", message);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsLoading(true);
        const file = e.dataTransfer.files[0];
        uploadImage(file).finally(() => setIsLoading(false));
    };

    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        setIsLoading(true);
        uploadImage(file).finally(() => setIsLoading(false));
    };

    return (
        <>
            <div>
                {isLoading && (<Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />)}

                <section className="site_hero patient_management_banner">
                    <div className="site_container">
                        <div className="site_row">
                            <div className="txt_colm">
                                <div className="txt_block">
                                    <h1>Update Testimonial</h1>
                                    <p>Edit and update existing testimonial information</p>
                                </div>
                            </div>
                            <div className="img_colm">
                                <div className="img_block">
                                    <img src={patient} alt="Patient" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mycustomclass patient_form_block">
                    <div className="site_container">
                        <div className="patient_form">
                            <div className="field_block">
                                <label>Quote*</label>
                                <input
                                    type="text"
                                    name="quote"
                                    className="text_field"
                                    placeholder="Enter Quote"
                                    value={testimonial.quote}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field_block">
                                <label>Name*</label>
                                <input
                                    type="text"
                                    name="author_name"
                                    className="text_field"
                                    placeholder="Enter Author Name"
                                    value={testimonial.author_name}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="field_block">
                                <label>Designation*</label>
                                <input
                                    type="text"
                                    name="author_title"
                                    className="text_field"
                                    placeholder="Enter Author Title"
                                    value={testimonial.author_title}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div
                                className="field_block col-md-6"
                                onDrop={handleDrop}
                                onDragOver={(e) => e.preventDefault()}
                            >
                                <div className="upload_field">
                                    <label>Please upload the patient's facial image</label>
                                    <div className="upload_ui">
                                        <label className="upload_ui_label">
                                            <input
                                                type="file"
                                                accept=".png, .jpg, .jpeg"
                                                onChange={handleChangeFile}
                                                style={{ display: "none" }}
                                            />
                                            <div className="ui_inner">
                                                <img src={upload_icon} alt="Upload" />
                                                <h5>Upload</h5>
                                                <p><span>Browse</span> to upload the file</p>
                                            </div>
                                        </label>
                                    </div>
                                    {testimonial.author_image && (
                                        <div className="record_seesion_info">
                                            <p className="sm_txt">
                                                <strong>{createShortNameFile(testimonial.author_image)}</strong>
                                            </p>
                                            <a
                                                href={testimonial.author_image}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="edit"
                                            >
                                                <i className="fa-solid fa-eye"></i>
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="field_block">
                                <div className="btn_row">
                                    <button disabled={isLoading || isSubmit} onClick={handleSubmit}>
                                        <span>Update</span> <img src={rightArrow} alt="Arrow" />
                                        {isSubmit && (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ToastContainer />
            </div>
        </>
    );
};
export default AdminTestimonialUpdate;
